module.exports = __webpack_public_path__ + "static/media/tk.b2df385f.svg";